export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: 'YouJia后台权限管理框架',
    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: 7,
    //图片地址
    imgDomain : process.env.NODE_ENV === 'development' ?"http://localhost:5000" : "https://www.weread.asia",
    //imgDomain : process.env.NODE_ENV === 'development' ?"https://localhost:5001" : "http://api.baiwansj.com",
    /**
     * @description api请求基础路径
     */
    baseUrl: {
      dev: 'http://localhost:5000/',
      pro: 'https://www.weread.asia/', 
      /* pro: 'http://api.baiwansj.com/', */
      defaultPrefix:"api/v1/"
    },
    authUrl: {
      dev: 'https://localhost:5001/api/oauth/auth',
      pro: 'https://localhost:5001/api/oauth/auth'
    },
    /**
     * @description 默认打开的首页的路由name值，默认为home
     */
    homeName: 'home',
    /**
     * @description 需要加载的插件
     */
    plugin: {
      'error-store': {
        showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
        developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
      }
    }
  }


// WEBPACK FOOTER //
// ./src/config.js